<template>
  <diV v-show="isLoaded">
    <div class="home">
      <img
        :src="require('@/images/background.png')"
        class="home-img"
        @load="onLoad"
      />
      <div class="home-content">
        開 口 部 性 能 か ん た ん 検 索 サ ー ビ ス
      </div>
      <div class="home-content-btn">
        <div>
          <v-btn class="start-button" @click="start">
            はじめる
          </v-btn>
        </div>
      </div>
      <div class="home-content-lable">
        <div class="message-container">
          <span style="font-size: 14px;font-weight: bold;">※本サービスはPCでのご利用を推奨しています</span>
        </div>
      </div>
      <div class="home-content-news">
        <div class="news-container" style="margin-top: 10px;">
          <div class="news-box">
            <!-- <pre class="wrap-pre">{{ newsmsgtext }}</pre> 20260204 html化-->
            <p v-html="newsmsgtext" class="vhtml-text" style="font-size: 14px;"></p>
          </div>
        </div>
      </div>
    </div>
  </diV>
  <!-- 背景画像のプリロード用 -->
  <img
    :src="backgroundImage"
    @load="onBackgroundLoad"
    style="display: none"
  />
</template>
<script>
import axios from 'axios'
import { useAuthStore } from '@/stores/auth'
export default {
  data () {
    return {
      isLoaded: false,
      backgroundImage: require('@/images/background.png'),
      backgroundLoaded: false,
      code: '',
      newsmsgtext: 'news'
    }
  },
  mounted () {
    const auth = useAuthStore()
    auth.setToken('init')
    this.startDisplay()
  },
  methods: {
    onLoad () {
      this.isLoaded = true
    },
    onBackgroundLoad () {
      // alert('load')
      this.backgroundLoaded = true
    },
    async startDisplay () {
      // alert(1)
      const auth = useAuthStore()
      axios.post('/api/init', {
        argtoken: auth.token
      })
        .then(response => {
          this.results = response.data
          if (this.results.status === 'NG') {
            alert('error ' + this.results.message)
            this.$router.push('/about')
          } else {
            auth.setToken('ok')
            auth.setTermstext(this.results.termstext)
            this.newsmsgtext = this.results.newstext.replace(/\r?\n/g, '<br>')
            // alert(this.results.token)
          }
        })
        .catch(error => {
          this.dialogsw = false
          alert('error  ' + error)
          this.$router.push('/about')
        })
    },
    async start () {
      const auth = useAuthStore()
      auth.setBsw('1') // 戻るボタン制御用
      auth.setRegion('')
      // auth.currentId = '/terms'
      this.$router.push('/terms')
    }
  }
}
</script>
<style scoped>
.home {
  position: relative;
  width: 100%;
  max-width: 1208px;   /* ← ここを基準にする */
  margin: 0 auto;
  aspect-ratio: 1179 / 786;
}

.home-img {
  width: 100%;
  height: 700px;   /* ← ここを調整すると縦を縮めることができる */
  object-fit: fill; /* ← 余白を絶対出さない */
  display: block;
}

/* 黒帯 */
.home-content {
  position: absolute;
  top: calc(45 / 786 * 100%); /* 元画像の上から100px位置 */
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.8); /* 少し透過させてもOK */
  color: white;
  font-size: 48px;
  text-align: center;
  padding: 5px 0;
}
.home-content-btn {
  position: absolute;
  top: calc(325 / 786 * 100%); /* 元画像の上から100px位置 */
  width: 100%;
  display: flex;
  justify-content: center;   /* 横中央 */
}
.home-content-lable {
  position: absolute;
  top: calc(380 / 786 * 100%); /* 元画像の上から100px位置 */
  width: 100%;
  display: flex;
  justify-content: center;   /* 横中央 */
}
.home-content-news {
  position: absolute;
  top: calc(475 / 786 * 100%); /* 元画像の上から100px位置 */
  width: 100%;
  display: flex;
  justify-content: center;   /* 横中央 */
}
</style>
<style scoped>
.news-container {
  max-width: 650px;
  width: 100%;               /* 親幅いっぱい */
  display: flex;             /* 中の news-box を中央に */
  justify-content: center;
  padding: 5px;
}
.news-box {
  text-align: left;
  white-space: pre-wrap;
  height: 135px;
  overflow-y: auto;
  border: 1px solid #ccc;
  padding: 5px;
  margin-bottom: 1rem;
  background-color: #f9f9f9;
}
.wrap-pre {
  white-space: pre-wrap; /* 改行を保持しつつ折り返す */
  word-wrap: break-word; /* 長い単語を折り返す */
}
.vhtml-text {
  line-height: 1.3; /* 調整。1.0?1.3あたり */
}
</style>
<style scoped>
.title-wrapper {
  position: relative;
  display: inline-block;
}

.title-background {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3.5em;
  background-color: rgba(255, 255, 255, 0.5); /* 白50%透過 */
  z-index: 0;
}

.title-text {
  position: relative;
  font-size: 36px;
  color: black;
  z-index: 1;
  margin: 0;
}
.custom-button {
  font-size: 18px;
  line-height: 50px; /* ボタンの高さに合わせて中央に配置 */
  padding: 0;
}
</style>
<style scoped>
.start-button {
  background-color: #1976d2; /* 塗りの色 */
  border: 3px solid white; /* 枠線の色 */
  color: white; /* 文字の色 */
  width: 340px;
  height: 50px;
  font-size: 24px;
  border-radius: 8px;        /* 角を丸くする（例えば12px） */
}
.message-container {
  width: 340px;
  height: 30px;
  background-color: rgba(255, 255, 255, 0.7);  /* 白の半透明 */
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;  /* 角を少し丸くしたい場合 */
}
</style>
